module.exports = __webpack_public_path__ + "static/media/semantic_pixelator.7cc5464a.jpg";